import { useAuth as useOidcAuthContext } from 'react-oidc-context';

const createFallbackAuth = () => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,
  error: undefined,
  signinRedirect: async () => {},
  signinRedirectCallback: async () => {},
  signoutRedirect: async () => {},
  removeUser: async () => {},
  signinSilent: async () => {},
});

export const useOidcAuth = () => {
  let auth: ReturnType<typeof useOidcAuthContext> | undefined;
  try {
    auth = useOidcAuthContext();
  } catch {
    auth = undefined;
  }
  // react-oidc-context@3 returns `undefined` (with a console warning) instead
  // of throwing when `<AuthProvider>` is missing, so the try/catch alone is
  // not enough; coerce to the fallback shape so callers can destructure safely.
  return (auth ?? createFallbackAuth()) as ReturnType<typeof useOidcAuthContext>;
};
